import React from "react";

function SvgAi(props) {
  let blur = "";
  if(props.activeMove){
    blur=40;
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      id="illustrator"
      width={props.width}
      height={props.height}
      viewBox="0 0 17.854 17.854"
    >
      <path
        id="Path_16437"
        data-name="Path 16437"
        d="M17.854,17.854H0V0H17.854Z"
        fill="#fec478"
      />
      <path
        id="Path_16438"
        data-name="Path 16438"
        d="M264.927,17.854H256V0h8.927Z"
        transform="translate(-247.073)"
        fill="#fea832"
      />
      <path
        id="Path_16439"
        data-name="Path 16439"
        d="M45.762,45.762H30V30H45.762Z"
        transform="translate(-28.954 -28.954)"
        fill={"#994c0f"+blur}
      />
      <path
        id="Path_16440"
        data-name="Path 16440"
        d="M263.881,45.762H256V30h7.881Z"
        transform="translate(-247.073 -28.954)"
        fill={"#713708"+(blur-20)}
      />
      <path
        id="Path_16441"
        data-name="Path 16441"
        d="M144.73,181.6h1.021l2.26,5.942h-1.188l-.552-1.481h-2.076l-.544,1.481h-1.188Zm1.331,3.649-.82-2.335-.854,2.335Z"
        transform="translate(-137.494 -175.267)"
        fill="#fec478"
      />
      <g
        id="Group_6604"
        data-name="Group 6604"
        transform="translate(8.927 6.165)"
      >
        <path
          id="Path_16442"
          data-name="Path 16442"
          d="M317.182,177.913V176.8H318.3v1.113Zm0,5v-4.385H318.3v4.385Z"
          transform="translate(-315.048 -176.8)"
          fill="#fea832"
        />
        <path
          id="Path_16443"
          data-name="Path 16443"
          d="M256,232.137v3.1l.4,1.076h1.188Z"
          transform="translate(-256 -230.207)"
          fill="#fea832"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgAi);
